export default __webpack_public_path__ + "061fdc1e15d4e76e3acbf1ef4833a9eb.png";